import { Box, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IPendingReview } from '~/domain/ShiftReview';
import { getShouldEnforcePermanentJobV2 } from '~/services/posthog/FeatureFlagUtils';

interface IProps {
  it: IPendingReview;
}

export const AdjustmentDetailV1 = ({ it }: IProps) => (
  <Column>
    {getShouldEnforcePermanentJobV2() && (
      <Box
        style={{
          alignSelf: 'flex-start',
          paddingBlock: 2,
          paddingInline: 10,
          marginBottom: 5,
          borderRadius: 8,
          backgroundColor: it?.isOnsiteInterview
            ? colors.favorites[50]
            : colors.primary[50],
        }}
      >
        <Typography size="caption" color={colors.neutral[500]}>
          {it?.isOnsiteInterview ? 'INTERVIEW' : 'SHIFT'}
        </Typography>
      </Box>
    )}

    <Typography bold>{it.shift.localDate}</Typography>

    <Column>
      <Typography
        color={colors.neutral[500]}
        style={{ textDecoration: it.hasAdjustShiftTime ? 'line-through' : 'none' }}
      >
        {it.shift.localStartTime} - {it.shift.localEndTime}
      </Typography>
      {it.hasAdjustShiftTime && (
        <Typography color={colors.neutral[500]}>
          {it.adjustment?.localStartTime} - {it.adjustment?.localEndTime}
        </Typography>
      )}
    </Column>

    <Column>
      <Typography
        color={colors.neutral[500]}
        style={{ textDecoration: it.hasAdjustBreakTime ? 'line-through' : 'none' }}
      >
        Meal Break: {it.shift.breakTime}
      </Typography>
      {it.hasAdjustBreakTime && (
        <Typography color={colors.neutral[500]}>
          Meal Break: {it.adjustment?.breakTime}
        </Typography>
      )}
    </Column>
  </Column>
);
